import { ReactNode } from 'react'

export type SettingsCardContentProps = {
  children?: ReactNode
}

export function SettingsCardContent({ children }: SettingsCardContentProps) {

  return (
    <div className="flex flex-col gap-4">
      { children }
    </div>
  )
}
